<template>
  <div class="row g-3">
    <div class="col-md-3">
      <label :for="legalFormId" class="form-label">
        {{ $t("go_cancel.form.tge_legal_form.label") }}
        <span class="text-danger">*</span>
      </label>
      <select
        :id="legalFormId"
        v-model="legalForm"
        class="form-select form-select-sm"
        :class="{ 'is-invalid': showLegalFormError }"
        @change="$emit('touch')"
      >
        <option :value="null" disabled>
          {{ $t("go_cancel.form.tge_legal_form.placeholder") }}
        </option>
        <option v-for="form in TGE_LEGAL_FORMS" :key="form" :value="form">
          {{ $t(`go_cancel.form.tge_legal_form.options.${form}`) }}
        </option>
      </select>
      <div v-if="isDetected" class="form-text">
        {{ $t("go_cancel.form.tge_legal_form.detected_hint") }}
      </div>
      <div v-else-if="isUndetectable" class="form-text text-danger">
        {{ $t("go_cancel.form.tge_legal_form.not_detected_hint") }}
      </div>
    </div>
    <div class="col-md-2">
      <label :for="vatNumberId" class="form-label">
        {{ $t("go_cancel.form.tge_vat_number.label") }}
      </label>
      <input
        :id="vatNumberId"
        v-model="vatNumber"
        type="text"
        maxlength="12"
        class="form-control form-control-sm"
        :placeholder="$t('go_cancel.form.tge_vat_number.placeholder')"
        @blur="$emit('touch')"
      />
      <div class="form-text">
        {{ $t("go_cancel.form.tge_vat_number.hint") }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TGE_LEGAL_FORMS, type TgeLegalForm } from "@/types";
import { computed, useId } from "vue";

const props = defineProps<{
  /** Undefined until the backend has answered; null when the name carries no legal-form designation. */
  detectedLegalForm?: TgeLegalForm | null;
  touched: boolean;
}>();

defineEmits<{
  touch: [];
}>();

const legalForm = defineModel<TgeLegalForm | null>("legalForm", {
  default: null,
});
const vatNumber = defineModel<string | null>("vatNumber", { default: null });

const legalFormId = useId();
const vatNumberId = useId();

const isDetected = computed(
  () => !!legalForm.value && legalForm.value === props.detectedLegalForm
);

const isUndetectable = computed(
  () => !legalForm.value && props.detectedLegalForm === null
);

const showLegalFormError = computed(
  () => !legalForm.value && (props.touched || isUndetectable.value)
);
</script>
